import { useEffect, useState, useRef, useMemo } from 'react';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LeftOptions from './leftOptions';
import RightContentActionPermissions from './rightContentActionPermissions';
import UiPermissions from './uiPermissions';
import { updateUserDetail } from '../../redux/reducer';
import { useDispatch } from 'react-redux';

function RoleManagement() {
  const dispatch = useDispatch();
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const [roleId, setRoleId] = useState();
  const [loading, setLoading] = useState(true);
  const [selectedOptionRoleManagement, setSelectedOptionRoleManagement] = useState('');
  const [isActive, setIsActive] = useState(false);
  const [dropItems, setDropItems] = useState();
  const [selected, setSelected] = useState(dropItems);
  const [options, setOptions] = useState([]);
  const [showoptionsRoleManagement, setShowOptionsRoleManagement] = useState(options[0]);
  const [uiPermissionsModuleName, setUiPermissionsModuleName] = useState([]);
  const [activeOptionRoleManagement, setActiveOptionRoleManagement] = useState();
  const [uiPermissionsData, setUiPermissionsData] = useState();
  const [showoptionsUiPermissions, setShowOptionsUiPermissions] = useState();
  const [checkboxes, setCheckboxes] = useState();
  const [activeOptionUiPermissions, setActiveOptionUiPermissions] = useState();
  const [permissionForParticularRoleInSaveFormat, setPermissionForParticularRoleInSaveFormat] =
    useState();
  const [permissionByModule, setPermissionByModule] = useState();
  const [permissionId, setPermissionId] = useState([]);
  const [updatedPermissions, setUpdatePermissions] = useState();
  const accountDetail = JSON.parse(localStorage.getItem('userDetail'));
  const [isRoleChange, setIsRoleChange] = useState(false);
  const [activeTab, setActiveTab] = useState('Permissions');

  const [permissionSubTab, setPermissionSubTab] = useState('action');
  const [formatedUiPermissions, setFormatedUiPermissions] = useState();
  const [recordVisibility, setRecordVisibility] = useState([]);

  const VISIBILITY_OPTIONS = [
    { value: 'own', label: 'Own records only', description: 'Only records the user owns', icon: 'bi bi-person' },
    { value: 'team', label: 'Team records', description: 'Records owned by their team', icon: 'bi bi-people' },
    { value: 'smartBuckets', label: 'Smart Bucket(s)', description: 'Records in their smart buckets', icon: 'bi bi-list' },
    { value: 'all', label: 'All records', description: 'Every record across the org', icon: 'bi bi-building' },
  ];

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleVisibilityToggle = (value) => {
    setRecordVisibility((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };
  const handleSelectOptionRoleManagement = (option) => {
    setSelectedOptionRoleManagement(option);
    setShowOptionsRoleManagement(option);
    setActiveOptionRoleManagement(option);
  };
  useEffect(() => {
    setActiveOptionUiPermissions(uiPermissionsModuleName[0]);
    setShowOptionsUiPermissions(uiPermissionsModuleName[0]);
  }, [uiPermissionsModuleName]);

  const handleRoleSelect = (role) => {
    setSelected(role.name);
    setRoleId(role.id);
  };

  //get roles list
  useEffect(() => {
    // Call the API service method
    apiServices
      .getRoleList()
      .then((response) => {
        let tmpData = response.data.rolesList;
        const roleNames = tmpData.map((roles) => ({
          id: roles.id,
          name: roles.roleName,
        }));
        setDropItems(roleNames);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }, []);

  //get Permission Group list
  useEffect(() => {
    // Call the API service method
    apiServices
      .getPermissionGroup()
      .then((response) => {
        let tmpData = response.data.permissionList;
        const permissionGroups = tmpData.map((permissions) => permissions.moduleName);
        const uniquePermissionGroups = [...new Set(permissionGroups)];
        setOptions(uniquePermissionGroups);
        // Create an array to store permission groups according to module names
        const moduleToPermissionGroups = {};
        tmpData.forEach((group) => {
          const { moduleName, permissionDisplayName, permissionId, permissionType } = group;
          if (!moduleToPermissionGroups[moduleName]) {
            moduleToPermissionGroups[moduleName] = { action: {}, field: {}, ui: {} };
          }
          const typeKey = (permissionType || '').toLowerCase();
          const validType = ['action', 'field', 'ui'].includes(typeKey) ? typeKey : 'action';
          moduleToPermissionGroups[moduleName][validType][permissionDisplayName] = {
            id: permissionId,
            ischecked: false,
            displayName: permissionDisplayName,
          };
        });
        setPermissionByModule(moduleToPermissionGroups);
        if (response.status === 200) {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        setLoading(false);
      });
  }, [roleId]);

  //get Permission By Roles
  useEffect(() => {
    if (roleId) {
      setLoading(true);
      // Call the API service method
      apiServices
        .getPermissionsByRole(roleId)
        .then((response) => {
          let tmpData = response.data.role.rolePermissions;
          const permissionGroups = tmpData.map((permissions) => permissions.moduleName);
          const uniquePermissionGroups = [...new Set(permissionGroups)];
          uniquePermissionGroups.forEach((value) => {
            if (!options.includes(value)) {
              options.push(value);
            }
          });

          // Create an array to store permission groups according to module names
          const moduleToPermissionGroups = {};
          let permissionGroupIds = [];
          let uniquePermissionGroupIds;

          // Iterate through the uniquePermissionGroups data
          tmpData.forEach((group) => {
            const { moduleName, permissionDisplayName, permissionId } = group;

            // Check if the module name already exists in the array
            if (!moduleToPermissionGroups[moduleName]) {
              moduleToPermissionGroups[moduleName] = [];
            }

            // Set the permissionGroupValue to false in the object
            moduleToPermissionGroups[moduleName][permissionDisplayName] = permissionId;
            permissionGroupIds.push(permissionId);
            // To ensure uniqueness:
            uniquePermissionGroupIds = Array.from(new Set(permissionGroupIds));
            setPermissionId(uniquePermissionGroupIds);

            uniquePermissionGroupIds.forEach((id) => {
              for (const key in permissionByModule) {
                for (const typeKey of ['action', 'field', 'ui']) {
                  if (!permissionByModule[key][typeKey]) continue;
                  for (const subKey in permissionByModule[key][typeKey]) {
                    if (permissionByModule[key][typeKey][subKey].id === id) {
                      permissionByModule[key][typeKey][subKey].ischecked = true;
                    }
                  }
                }
              }
            });
          });
          setUpdatePermissions(permissionByModule);
          setSelectedOptionRoleManagement(tmpData[0].moduleName);
          setShowOptionsRoleManagement(tmpData[0].moduleName);
          setActiveOptionRoleManagement(tmpData[0].moduleName);

          if (response.status === 200) {
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          setLoading(false);
        });
    }
  }, [roleId, isRoleChange]);

  // Function to handle the save action
  const handleSaveRoleManagement = () => {
    setLoading(true);
    const data = {
      roleAndPermissionMapping: {
        roleId: roleId,
        permissionIds: permissionId,
      },
    };
    // Call the API service method
    apiServices
      .savePermissionsByRole(data)
      .then((response) => {
        let tmpData = response.data;
        if (response.status === 200) {
          setIsRoleChange(true);
          toast.success('Action Permission updated successfully!', {
            position: 'top-right',
          });
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        toast.error(`${error.message}`, { position: 'top-right' });
        setLoading(false);
      });
  };

  // Define the callback function to receive data from the child
  const receiveDataFromChild = (data) => {
    if (data.length > 0)
      if (permissionId.includes(data[0])) {
        // Uncheck the checkbox and remove its ID from the state
        uncheckCheckbox(data[0]);
      } else {
        // Check the checkbox and add its ID to the state
        checkCheckbox(data[0]);
      }
  };

  const checkCheckbox = (id) => {
    setPermissionId((prevPermissionId) => {
      if (prevPermissionId.includes(id)) {
        // If the ID is already in the array, return it as is
        return prevPermissionId;
      } else {
        // If the ID is not in the array, add it
        return [...prevPermissionId, id];
      }
    });
  };

  const uncheckCheckbox = (id) => {
    setPermissionId((prevPermissionId) => {
      // Filter out the ID to remove it
      return prevPermissionId.filter((checkboxId) => checkboxId !== id);
    });
  };

  //To close the dropdown when clicked outside
  const dropdownRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (accountDetail && isRoleChange)
      apiServices
        .getUserDetail(accountDetail.localAccountId)
        .then((response) => {
          if (response.status === 200) {
            setIsRoleChange(false);
            localStorage.setItem('userInformation', JSON.stringify(response.data.user));
            dispatch(
              updateUserDetail({
                userInformation: response.data.user,
              })
            );
            const data = response.data.user.userPermissions;
            const uniquePermissionDisplayNames = [
              ...new Set(data.map((permission) => permission.permissionValue)),
            ];
            const uniqueDeniedPermissionDisplayNames = [
              ...new Set(
                response.data.user.permissionsDenied.map((permission) => permission.permissionValue)
              ),
            ];
            const filteredPermissions = uniquePermissionDisplayNames.filter(
              (permission) => !uniqueDeniedPermissionDisplayNames.includes(permission)
            );
            const uniqueGrantedPermissionDisplayNames = [
              ...new Set(
                response.data.user.permissionsGranted.map(
                  (permission) => permission.permissionValue
                )
              ),
            ];
            // Check for permissions granted but not in access permissions, and add them
            uniqueGrantedPermissionDisplayNames.forEach((permission) => {
              if (!filteredPermissions.includes(permission)) {
                filteredPermissions.push(permission);
              }
            });
            // localStorage.setItem("accessPermissions", filteredPermissions);
            dispatch(
              updateUserDetail({
                accessPermissions: filteredPermissions,
              })
            );
          }
        })
        .catch((error) => {
          // Handle errors
          setLoading(false);
        });
  }, [isRoleChange]);
  useEffect(() => {
    setLoading(true);
    apiServices
      .getUiPermissions()
      .then((response) => {
        const tmpData = response.data.uiPermissionList;
        const permissionGroups = tmpData.map((permissions) => permissions.moduleName);
        const uniquePermissionGroups = [...new Set(permissionGroups)];
        setUiPermissionsModuleName(uniquePermissionGroups);
        setActiveOptionUiPermissions(uiPermissionsModuleName[0]);

        const formattedData = {};

        // Group permissions by module name
        tmpData.forEach((permission) => {
          const { moduleName } = permission;

          if (!formattedData[moduleName]) {
            formattedData[moduleName] = {
              menuPermissions: [],
              screens: [],
              fields: [],
            };
          }

          // Assign permissions to their respective arrays based on type
          switch (permission.permissionTypeName) {
            case 'Menu':
              formattedData[moduleName].menuPermissions.push(permission);
              break;
            case 'Screen':
              formattedData[moduleName].screens.push(permission);
              break;
            case 'Field':
              formattedData[moduleName].fields.push(permission);
              break;
            default:
              break;
          }
        });

        // Link screens to their respective menus and fields to their respective screens
        Object.values(formattedData).forEach((moduleData) => {
          moduleData.menuPermissions.forEach((menu) => {
            // Initialize an array to hold screens for this menu
            menu.screenPermissions = [];

            // Iterate through each screen permission
            moduleData.screens.forEach((screen) => {
              // If the screen permission's parent ID matches the menu's permission ID
              if (screen.permissionParentId === menu.permissionId) {
                // Initialize an array to hold fields for this screen
                screen.fieldPermissions = [];

                // Iterate through each field permission
                moduleData.fields.forEach((field) => {
                  // If the field permission's parent ID matches the screen's permission ID
                  if (field.permissionParentId === screen.permissionId) {
                    // Add the field permission to the fields array of this screen
                    screen.fieldPermissions.push(field);
                  }
                });

                // Add the screen to the screens array of this menu
                menu.screenPermissions.push(screen);
              }
            });
          });
        });
        Object.keys(formattedData).forEach((moduleName) => {
          delete formattedData[moduleName].screens;
          delete formattedData[moduleName].fields;
        });
        // console.log(formattedData);
        setFormatedUiPermissions(formattedData);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error:', error);
        setLoading(false);
      });
  }, []);

  const handleSelectOptionUiPermissions = (option) => {
    setShowOptionsUiPermissions(option);
    setActiveOptionUiPermissions(option);
    if (uiPermissionsData?.hasOwnProperty(option)) {
      // Update the checkboxes state with data from the selected option
      setCheckboxes(uiPermissionsData[option]);
    } else {
      // Handle case where selected option data is not found
      console.error(`Data for option '${option}' not found.`);
    }
  };

  const handleCheckboxChange = (option, permission, permissionId) => {
    // Clone the checkboxes state
    const updatedCheckboxes = { ...checkboxes };

    if (option === 'menuPermissions') {
      // Update the isChecked property of the menu permission
      const menuPermission = updatedCheckboxes.menuPermissions.find(
        (menu) => menu.permissionId === permissionId
      );
      if (menuPermission) {
        menuPermission.isChecked = !menuPermission.isChecked;
        menuPermission.canView = !menuPermission.canView;

        // Update isChecked for all associated screen permissions
        if (!menuPermission.isChecked) {
          menuPermission.screenPermissions.forEach((screen) => {
            screen.isChecked = false;
            screen.canView = false;
            // Update isChecked for all associated field permissions
            if (screen.fieldPermissions) {
              screen.fieldPermissions.forEach((field) => {
                field.isChecked = false;
                field.canEdit = false;
                field.canView = false;
              });
            }
          });
        }
      }
    } else if (option === 'screenPermissions') {
      // Find the corresponding menu permission and update its isChecked property
      const menuPermission = updatedCheckboxes.menuPermissions.find((menu) => {
        return (
          menu.screenPermissions &&
          menu.screenPermissions.some((screen) => screen.permissionId === permissionId)
        );
      });

      if (menuPermission) {
        menuPermission.isChecked = true;
        menuPermission.canView = true;
      }

      // Update the isChecked property of the screen permission
      const screenPermission = updatedCheckboxes.menuPermissions.reduce((found, menu) => {
        return (
          found ||
          (menu.screenPermissions &&
            menu.screenPermissions.find((screen) => screen.permissionId === permissionId))
        );
      }, null);

      if (screenPermission) {
        screenPermission.isChecked = !screenPermission.isChecked;
        screenPermission.canView = !screenPermission.canView;

        // Update isChecked for all associated field permissions
        if (!screenPermission.isChecked && screenPermission.fieldPermissions) {
          screenPermission.fieldPermissions.forEach((field) => {
            field.isChecked = false;
            field.canEdit = false;
            field.canView = false;
          });
        }
      }

      // If canEdit is checked and canView is unchecked, check canView
      if (screenPermission.isChecked && !screenPermission.canView && screenPermission.canEdit) {
        screenPermission.canView = true;
      }
    } else if (option === 'fieldPermissions' || option === 'canView' || option === 'canEdit') {
      // Find the corresponding field permission
      let fieldPermission;
      let parentScreenPermission;
      let parentMenuPermission;

      // Loop through permissions to find the parent permissions
      for (const menu of updatedCheckboxes.menuPermissions) {
        for (const screen of menu.screenPermissions) {
          if (screen.fieldPermissions) {
            fieldPermission = screen.fieldPermissions.find(
              (field) => field.permissionId === permissionId
            );
            if (fieldPermission) {
              parentScreenPermission = screen;
              parentMenuPermission = menu;
              break;
            }
          }
        }
        if (fieldPermission) break;
      }

      // Update the canEdit and canView properties of the field permission
      if (fieldPermission) {
        // Toggle canEdit and canView properties
        if (option === 'canEdit') {
          // Toggle the canEdit property
          fieldPermission.canEdit = !fieldPermission.canEdit;
        } else if (option === 'canView') {
          // Toggle the canView property
          fieldPermission.canView = !fieldPermission.canView;
        }

        // If canEdit is checked and canView is unchecked, check canView
        if (fieldPermission.canEdit && !fieldPermission.canView) {
          fieldPermission.canView = true;
        }

        // If either canEdit or canView is checked, check the parent checkboxes
        if (fieldPermission.canEdit || fieldPermission.canView) {
          parentScreenPermission.isChecked = true;
          parentMenuPermission.isChecked = true;
          parentScreenPermission.canView = true;
          parentMenuPermission.canView = true;
        }
      }
    }

    // Update the state
    setCheckboxes({
      ...updatedCheckboxes,
    });
    // console.log("Updated Checkboxes", checkboxes);
    updateCheckBoxesForSaveFunction();
  };

  const updateCheckBoxesForSaveFunction = () => {
    // Take data into variables for easier access
    const checkboxesData = checkboxes.menuPermissions;
    const permissionsData =
      permissionForParticularRoleInSaveFormat.roleUiPermissionsVm.roleAndUiPermissions;

    // Iterate over permissionsData
    permissionsData.forEach((permission) => {
      // Iterate over checkboxesData to find a match
      checkboxesData.forEach((menuPermission) => {
        // Check if the permissionId matches
        if (menuPermission.permissionId === permission.uiPermissionId) {
          // Update permissionForParticularRoleInSaveFormat with values from checkboxes
          permission.canCreate = menuPermission.canCreate;
          permission.canDelete = menuPermission.canDelete;
          permission.canEdit = menuPermission.canEdit;
          permission.canView = menuPermission.canView;
        } else {
          // If permissionId does not match, check screenPermissions
          menuPermission.screenPermissions.forEach((screenPermission) => {
            if (screenPermission.permissionId === permission.uiPermissionId) {
              // Update permissionForParticularRoleInSaveFormat with values from checkboxes
              permission.canCreate = screenPermission.canCreate;
              permission.canDelete = screenPermission.canDelete;
              permission.canEdit = screenPermission.canEdit;
              permission.canView = screenPermission.canView;
            } else {
              // If permissionId does not match, check fieldPermissions
              screenPermission.fieldPermissions.forEach((fieldPermission) => {
                if (fieldPermission.permissionId === permission.uiPermissionId) {
                  // Update permissionForParticularRoleInSaveFormat with values from checkboxes
                  permission.canCreate = fieldPermission.canCreate;
                  permission.canDelete = fieldPermission.canDelete;
                  permission.canEdit = fieldPermission.canEdit;
                  permission.canView = fieldPermission.canView;
                }
              });
            }
          });
        }
      });
    });
    // console.log("Permission CheckBoxes Change Over Handle",permissionForParticularRoleInSaveFormat);
    setPermissionForParticularRoleInSaveFormat(permissionForParticularRoleInSaveFormat);
  };

  useEffect(() => {
    if (roleId) {
      setLoading(true);
      apiServices
        .getUiPermissionsByRoleId(roleId)
        .then((response) => {
          let tmpData = response.data.roleUiPermissions;
          let uiPermissions = formatedUiPermissions;

          // Loop through each module
          Object.keys(uiPermissions).forEach((moduleKey) => {
            // Loop through menuPermissions in the current module
            uiPermissions[moduleKey].menuPermissions.forEach((menuPermission) => {
              // Initialize isChecked property to false for all menuPermissions
              menuPermission.isChecked = tmpData.some(
                (permission) => permission.permissionId === menuPermission.permissionId
              );

              // Find the corresponding permission in tmpData and set the canCreate, canView, and canEdit values
              const correspondingPermission = tmpData.find(
                (permission) => permission.permissionId === menuPermission.permissionId
              );
              if (correspondingPermission) {
                menuPermission.canCreate = correspondingPermission.canCreate;
                menuPermission.canView = correspondingPermission.canView;
                menuPermission.canEdit = correspondingPermission.canEdit;
              }

              // Loop through screenPermissions in the current menuPermission
              menuPermission.screenPermissions.forEach((screenPermission) => {
                // Initialize isChecked property to false for all screenPermissions
                screenPermission.isChecked = tmpData.some(
                  (permission) => permission.permissionId === screenPermission.permissionId
                );

                // Find the corresponding permission in tmpData and set the canCreate, canView, and canEdit values
                const correspondingPermission = tmpData.find(
                  (permission) => permission.permissionId === screenPermission.permissionId
                );
                if (correspondingPermission) {
                  screenPermission.canCreate = correspondingPermission.canCreate;
                  screenPermission.canView = correspondingPermission.canView;
                  screenPermission.canEdit = correspondingPermission.canEdit;
                }

                // Loop through fieldPermissions in the current screenPermission
                screenPermission.fieldPermissions.forEach((fieldPermission) => {
                  // Initialize isChecked property to false for all fieldPermissions
                  fieldPermission.isChecked = tmpData.some(
                    (permission) => permission.permissionId === fieldPermission.permissionId
                  );

                  // Find the corresponding permission in tmpData and set the canCreate, canView, and canEdit values
                  const correspondingPermission = tmpData.find(
                    (permission) => permission.permissionId === fieldPermission.permissionId
                  );
                  if (correspondingPermission) {
                    fieldPermission.canCreate = correspondingPermission.canCreate;
                    fieldPermission.canView = correspondingPermission.canView;
                    fieldPermission.canEdit = correspondingPermission.canEdit;
                  } else {
                    fieldPermission.canView = false;
                    fieldPermission.canEdit = false;
                  }
                });
              });
            });
          });

          const convertToSaveFormat = (uiPermissions) => {
            const roleAndUiPermissions = [];

            for (const moduleName in uiPermissions) {
              if (uiPermissions.hasOwnProperty(moduleName)) {
                const moduleData = uiPermissions[moduleName];

                moduleData.menuPermissions.forEach((menuPermission) => {
                  const roleAndUiPermissionMenu = {
                    roleId: roleId,
                    uiPermissionId: menuPermission.permissionId,
                    canCreate: menuPermission.canCreate,
                    canDelete: menuPermission.canDelete,
                    canEdit: menuPermission.canEdit,
                    canView: menuPermission.canView,
                  };
                  roleAndUiPermissions.push(roleAndUiPermissionMenu);

                  menuPermission.screenPermissions.forEach((screenPermission) => {
                    const roleAndUiPermissionScreen = {
                      roleId: roleId,
                      uiPermissionId: screenPermission.permissionId,
                      canCreate: true,
                      canDelete: true,
                      canEdit: true,
                      canView: screenPermission.canView,
                    };
                    roleAndUiPermissions.push(roleAndUiPermissionScreen);

                    screenPermission.fieldPermissions.forEach((fieldPermission) => {
                      const roleAndUiPermissionField = {
                        roleId: roleId,
                        uiPermissionId: fieldPermission.permissionId,
                        canCreate: true,
                        canDelete: true,
                        canEdit: fieldPermission.canEdit,
                        canView: fieldPermission.canView,
                      };
                      roleAndUiPermissions.push(roleAndUiPermissionField);
                    });
                  });
                });
              }
            }

            return { roleUiPermissionsVm: { roleAndUiPermissions } };
          };
          // Usage
          const formattedJsonForSave = convertToSaveFormat(uiPermissions);
          setPermissionForParticularRoleInSaveFormat(formattedJsonForSave);
          // Now the formatedUiPermissions will contain the isChecked, canCreate, canView, and canEdit properties set based on matching permissions
          setUiPermissionsData(uiPermissions);
          setCheckboxes(uiPermissions[showoptionsUiPermissions]);

          setLoading(false);
        })
        .catch((error) => {
          console.error('Error:', error);
          setLoading(false);
        });
    }
  }, [roleId]);

  return (
    <>
      <div className="inner-page" style={containerStyle}>
        <div className="dash-container">
          <div className="tbl_container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12">
                <div className="main-hd">
                  <div className="pagetitle">
                    {' '}
                    <img src="../assets/images/role-management-icons/left-arrow.png" alt="" />{' '}
                    Role-Management
                  </div>

                  <div className="graydiv">
                    <div className="div2">
                      <div className="para">
                        <p>Role:&nbsp;&nbsp;</p>
                        <div
                          className="dropdown"
                          onClick={(e) => setIsActive(!isActive)}
                          ref={dropdownRef}
                        >
                          <div className="dropdown-btn">
                            {selected || 'Select a Role'}{' '}
                            {/* Display the selected role or placeholder text */}
                          </div>
                          <span className="fas fa-caret-down">
                            <i className="bi bi-chevron-down"></i>
                          </span>
                          {isActive && (
                            <div className="dropdown-content">
                              {dropItems?.map((role) => (
                                <div
                                  className="dropdown-item"
                                  key={role.name}
                                  onClick={() => {
                                    handleRoleSelect({
                                      id: role.id,
                                      name: role.name,
                                    });
                                    setIsActive(false);
                                  }}
                                >
                                  {role.name}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div></div>
                </div>

                <div className="test">
                  {loading ? ( // Step 3: Conditionally render the loading overlay
                    <div className="custom-loading-overlay">
                      <div className="custom-loading-image"></div>
                    </div>
                  ) : (
                    <>
                      <div className="roleManagement-nav">
                        <div className="roleMgmt">
                          <ul className="nav nav-underline">
                            <li className="nav-item">
                              <a
                                className={`nav-link ${activeTab === 'Permissions' ? 'active' : ''}`}
                                onClick={() => handleTabClick('Permissions')}
                              >
                                Permissions
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className={`nav-link ${activeTab === 'Records Visibility' ? 'active' : ''}`}
                                onClick={() => handleTabClick('Records Visibility')}
                              >
                                Records Visibility
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className={`nav-link ${activeTab === 'UI Visibility' ? 'active' : ''}`}
                                onClick={() => handleTabClick('UI Visibility')}
                              >
                                UI Visibility
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div>
                        {selected && selected.length > 0 ? (
                          <div>
                            <div className="parentdiv">
                              {activeTab === 'Permissions' && (
                                <>
                                  <div className="whitediv">
                                    <LeftOptions
                                      options={options}
                                      onSelectOption={handleSelectOptionRoleManagement}
                                      activeOption={activeOptionRoleManagement}
                                    />
                                    {showoptionsRoleManagement !== undefined ? (
                                      <>
                                        <RightContentActionPermissions
                                          selectedOption={showoptionsRoleManagement}
                                          permissionByModule={updatedPermissions}
                                          permissionId={permissionId}
                                          sendDataToParent={receiveDataFromChild}
                                          permissionSubTab={permissionSubTab}
                                          onSubTabChange={setPermissionSubTab}
                                          onSave={handleSaveRoleManagement}
                                        />
                                      </>
                                    ) : (
                                      <>
                                        <RightContentActionPermissions
                                          selectedOption={options[0]}
                                          permissionByModule={permissionByModule}
                                          permissionId={permissionId}
                                          sendDataToParent={receiveDataFromChild}
                                          permissionSubTab={permissionSubTab}
                                          onSubTabChange={setPermissionSubTab}
                                          onSave={handleSaveRoleManagement}
                                        />
                                      </>
                                    )}
                                  </div>
                                </>
                              )}
                              {activeTab === 'UI Visibility' && (
                                <UiPermissions
                                  options={options}
                                  onSelectOption={handleSelectOptionUiPermissions}
                                  activeOption={activeOptionRoleManagement}
                                  roleId={roleId}
                                  formatedUiPermissions={formatedUiPermissions}
                                  uiPermissionsModuleName={uiPermissionsModuleName}
                                  uiPermissionsData={uiPermissionsData}
                                  showoptionsUiPermissions={showoptionsUiPermissions}
                                  handleSelectOptionUiPermissions={handleSelectOptionUiPermissions}
                                  activeOptionUiPermissions={activeOptionUiPermissions}
                                  checkbox={checkboxes}
                                  handleCheckboxChange={handleCheckboxChange}
                                  permissionForParticularRoleInSaveFormat={
                                    permissionForParticularRoleInSaveFormat
                                  }
                                />
                              )}
                              {activeTab === 'Records Visibility' && (
                                <div className="record-visibility-container">
                                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                                    <p className="record-visibility-subtitle" style={{ margin: 0 }}>
                                      The default set of records this role can see.
                                    </p>
                                    <button className="save-btn" style={{ float: 'none', marginBottom: 0, flexShrink: 0 }}>Save</button>
                                  </div>
                                  <div className="record-visibility-grid">
                                    {VISIBILITY_OPTIONS.map((opt) => {
                                      const isSelected = recordVisibility.includes(opt.value);
                                      return (
                                        <div
                                          key={opt.value}
                                          className={`record-visibility-card${isSelected ? ' selected' : ''}`}
                                          onClick={() => handleVisibilityToggle(opt.value)}
                                        >
                                          <div className="record-visibility-icon">
                                            <i className={opt.icon}></i>
                                          </div>
                                          <div className="record-visibility-text">
                                            <span className="record-visibility-label">{opt.label}</span>
                                            <span className="record-visibility-desc">{opt.description}</span>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div className="role-not-selected">
                            <img
                              src="../assets/images/team.png"
                              alt="Role Management"
                              width="150px"
                            />
                            <h1>Please select a role from the Role's dropdown</h1>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RoleManagement;
